import { Pipe, PipeTransform } from '@angular/core';

export const EMPTSTRING = '';

@Pipe({
  name: 'capitalize',
})
export class CapitalizePipe implements PipeTransform {

  transform(value: string, arg1?: any, arg2?: any): any {
    if (value && value.length > 0) {
      if (value.indexOf(' ') >= 0) {
        const strarray = value.split(' ');
        const retarray: Array<string> = [];
        strarray.forEach(str => {
          retarray.push(this.capitalize(str));
        });
        return retarray.join(' ');
      } else {
        return this.capitalize(value);
      }
    } else {
      return EMPTSTRING;
    }
  }

  capitalize(str: string) {
    if(str && str.length > 0) {
      return str.substring(0, 1).toUpperCase() + str.substring(1).toLowerCase();
    } else {
      return EMPTSTRING;
    }
  }

}
